












import Vue from 'vue'
import FilterDropdown from '@/pages/common/filter-dropdown/FilterDropdown.vue'
import {
  $types,
  typeDropdownModule,
  loadTypes,
  setSelectedType,
} from '@/pages/common/dropdowns/bank/lesson-tasks/type-dropdown/type-dropdown.model'
import { DropdownItem } from '@/pages/common/types'

export default Vue.extend({
  components: {
    FilterDropdown,
  },
  effector: {
    $types,
    ...typeDropdownModule.store,
  },
  methods: {
    ...typeDropdownModule.methods,
    onSelectItem(item: DropdownItem | null) {
      this.$emit('setItem', item ? item.name : null)
      setSelectedType(item)
    },
  },
  mounted() {
    loadTypes()
  },
})
